(() => {
	// Product list or grid view controller
	const gridButtons = document.querySelectorAll(".grid-button");
	if (gridButtons) {
		gridButtons.forEach((element) => {
			if (element.classList.contains("grid-active")) {
				const targetGrid = element.dataset.targetGrid;
				document
					.querySelectorAll(".grid-content")
					.forEach((content) => {
						if (content.getAttribute("id") !== targetGrid) {
							content.classList.add("hidden");
						}
					});
			}

			element.addEventListener("click", () => {
				const targetGrid = element.dataset.targetGrid;
				document
					.querySelectorAll(".grid-content")
					.forEach((content) => {
						if (content.getAttribute("id") === targetGrid) {
							content.classList.remove("hidden");
							content.classList.add("block");
						} else {
							content.classList.add("hidden");
							content.classList.remove("block");
						}
					});
			});
		});
	}
})();
